import application from 'application/application';
import textEditorTemplate from './text-editor.template.html';

import textEditorController from './text-editor.controller.js';

application.directive('ngTextEditor', [
	() => ({
		restrict: 'E',
		templateUrl: textEditorTemplate,
		controller: textEditorController
	})
]);